export const API_RULE = "/api/rules/rule"
export const API_RULE_SET = "/api/rules/ruleSet"
export const API_GET_RULE_SET = "/api/rules/getRuleSet"
export const API_RULE_COLLECTION = "/api/rules/ruleCollection"
export const API_GET_RULE_COLLECTION = "/api/rules/getRuleCollection"
export const API_XPATH_MAPPING = "/api/rules/XPathMapping"
export const API_TEST_VALIDATION_RULE = "/api/rules/testValidationRule"
export const API_TEST_VALIDATION_RULE_SET = "/api/rules/testValidationRuleSet"
export const API_TEST_VALIDATION_RULE_COLLECTION =
  "/api/rules/testValidationRuleCollection"
export const API_TEST_TRANSFORMATION_RULE = "/api/rules/testTransformationRule"
export const API_TEST_TRANSFORMATION_JS_RULE = "/api/rules/transformByJs"
export const API_TEST_TRANSFORMATION_RULE_SET =
  "/api/rules/testTransformationRuleSet"
export const API_TEST_TRANSFORMATION_RULE_COLLECTION =
  "/api/rules/testTransformationRuleCollection"
export const API_PROVIDER_CONFIGURATION = "/api/providers/providerConfiguration"



// WEBPACK FOOTER //
// ./src/MetadataRules/urls.js